module.exports = __webpack_public_path__ + "tables/media/glyphicons-halflings-regular.89889688.svg";